import React from 'react';
import './PolicyPage.css';

const RefundPolicy: React.FC = () => (
  <main className="policy-page">
    <h1>Refund Policy</h1>
    <p className="policy-updated">Last updated: September 23, 2026</p>
    <h2>1. Requesting a Refund</h2>
    <p>Contact us through My Orders, where available, or email us at hello@gimbiyastore.com with your order reference, reason for the request, and supporting information.</p>
    <h2>2. Review and Approval</h2>
    <p>Every request is reviewed against the applicable return conditions, item condition, proof of purchase, and the circumstances of the request. Submitting a request does not automatically guarantee approval.</p>
    <h2>3. Refund Method</h2>
    <p>Approved refunds will normally be processed using the appropriate payment process associated with the original transaction. Processing time may depend on payment providers, banks, and the information required to complete the refund.</p>
    <h2>4. Return Shipping Costs</h2>
    <p>The buyer generally bears return shipping costs. The amount depends on prevailing market rates. Where an item is confirmed to have been sent incorrectly or to have a verified defect, contact support for instructions before sending it back.</p>
    <h2>5. Non-Eligible Items</h2>
    <p>Some products may be excluded from return or refund because of hygiene, perishability, customization, damage caused after delivery, use, or other product-specific conditions. The applicable conditions will be communicated where relevant.</p>
    <h2>6. Contact</h2>
    <p>Email <a href="mailto:hello@gimbiyastore.com">hello@gimbiyastore.com</a> for assistance.</p>
  </main>
);
export default RefundPolicy;
